// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".route-info[data-v-1e826eb0]{position:relative;z-index:1;transform:translateZ(1px)}.route-border[data-v-1e826eb0]{--borderHeight:100px;position:absolute;left:7px;top:3px;border-right:1px dashed #979ca1;height:var(--borderHeight)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
